// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var extendObservable = require('mobx').extendObservable;

  function IntegrationSetting() {
    var props = {
      // For hidden license token and key on UI
      deploymentMode: 0,
      isIntegrationMode: function() {
        return this.deploymentMode > 0;
      }
    };

    extendObservable(this, props);
  }

  /**
   * read Integration Setting information response from api
   * @param  {object} response from api
   */
  IntegrationSetting.prototype.readDeploymentMode = function(response) {
    this.deploymentMode = response.deploymentMode;
  };

  module.exports = new IntegrationSetting();
}());



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.IntegrationSetting.js